/**
 * FE-FIX01. Backend принимает полный набор уровней иерархии на
 * GET /violations/events и GET /admin/violation-rules-v2:
 * factory_id, workshop_id, section_id, room_id, camera_id (все integer|null).
 * Проверено на проде 24.09.2026: ?factory_id=2 → total 52 против 1912 без фильтра.
 *
 * Отправляем только выбранные уровни: параметр с пустым значением backend
 * трактовать не обязан, а `cleanParams` в services/violations всё равно
 * вырезал бы его — здесь мы просто не создаём мусор.
 */
const LEVELS = [
  ['factoryId', 'factory_id'],
  ['workshopId', 'workshop_id'],
  ['sectionId', 'section_id'],
  ['roomId', 'room_id'],
  ['cameraId', 'camera_id'],
];

export const hierarchyParams = (hierarchy = {}) => {
  const params = {};
  LEVELS.forEach(([uiKey, apiKey]) => {
    const raw = hierarchy?.[uiKey];
    if (raw === '' || raw === null || raw === undefined) return;
    const value = Number(raw);
    if (!Number.isFinite(value)) return;
    params[apiKey] = value;
  });
  return params;
};
